// extracted by mini-css-extract-plugin
module.exports = {"mask":"mask--1Rr5g","modal":"modal--2NAUK","modalBox":"modalBox--2c6E_","fadeIn":"fadeIn--3nx9q","close":"close--2xdu5"};